import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';
import Select from '../../../components/ui/Select';

const PrivacyControlsSection = ({ formData, onPrivacyChange }) => {
  const messageAccessOptions = [
    { value: 'everyone', label: 'Everyone', description: 'Anyone can message you' },
    { value: 'verified', label: 'Verified Users Only', description: 'Only verified profiles can message' },
    { value: 'premium', label: 'Premium Members Only', description: 'Only paid subscribers can message' },
    { value: 'approved', label: 'Approved Contacts', description: 'Only users you approve can message' }
  ];

  const profileVisibilityOptions = [
    { value: 'public', label: 'Public', description: 'Visible to all users' },
    { value: 'limited', label: 'Limited', description: 'Visible to matched users only' },
    { value: 'private', label: 'Private', description: 'Visible only to approved contacts' }
  ];

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-warm">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <Icon name="Lock" size={24} color="var(--color-primary)" />
        <h3 className="text-lg md:text-xl font-heading font-semibold">Privacy Controls</h3>
      </div>
      <div className="space-y-5">
        <Select
          label="Message Access"
          name="messageAccess"
          description="Control who can send you messages"
          options={messageAccessOptions}
          value={formData?.messageAccess}
          onChange={(value) => onPrivacyChange('messageAccess', value)}
        />

        <Select
          label="Profile Visibility"
          name="profileVisibility"
          description="Control who can view your profile"
          options={profileVisibilityOptions}
          value={formData?.profileVisibility}
          onChange={(value) => onPrivacyChange('profileVisibility', value)}
        />

        <div className="space-y-3 pt-2">
          <Checkbox
            label="Show online status"
            description="Let others see when you're active"
            checked={formData?.showOnlineStatus}
            onChange={(e) => onPrivacyChange('showOnlineStatus', e?.target?.checked)}
          />

          <Checkbox
            label="Appear in search results"
            description="Allow your profile to be discovered in searches"
            checked={formData?.appearInSearch}
            onChange={(e) => onPrivacyChange('appearInSearch', e?.target?.checked)}
          />

          <Checkbox
            label="Show last active time"
            description="Display when you were last online"
            checked={formData?.showLastActive}
            onChange={(e) => onPrivacyChange('showLastActive', e?.target?.checked)}
          />

          <Checkbox
            label="Allow profile screenshots"
            description="Permit others to take screenshots of your profile"
            checked={formData?.allowScreenshots}
            onChange={(e) => onPrivacyChange('allowScreenshots', e?.target?.checked)}
          />
        </div>

        <div className="p-4 bg-error/10 rounded-lg">
          <div className="flex items-start gap-3">
            <Icon name="ShieldAlert" size={20} color="var(--color-error)" className="flex-shrink-0 mt-0.5" />
            <div>
              <h4 className="text-sm font-caption font-semibold mb-1 text-error">Privacy Notice</h4>
              <p className="text-xs text-foreground">
                Stricter privacy settings may limit your visibility and reduce connection opportunities. Balance privacy with discoverability based on your comfort level.
              </p>
            </div>
          </div>
        </div>

        <div className="p-4 bg-success/10 rounded-lg">
          <div className="flex items-start gap-3">
            <Icon name="CheckCircle2" size={20} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
            <div>
              <h4 className="text-sm font-caption font-semibold mb-1 text-success">Your Data is Protected</h4>
              <ul className="text-xs text-foreground space-y-1">
                <li>• End-to-end encryption for all messages</li>
                <li>• No data sharing with third parties</li>
                <li>• Complete control over your information</li>
                <li>• Secure data storage and transmission</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyControlsSection;